import React, {useState} from 'react'
import checkmarkGreen from '../images/checkmark-green.png'
import close from '../images/closeX.png'
import calendar from '../images/Icon-Calendar.png';
import moment from 'moment';
import { DayPicker  } from 'react-day-picker';
import da from "date-fns/locale/da";

function FilmlistDiv({item,index}) {
     const [filmDivOpen, setFilmDivOpen] = useState(false);
     const [clickedDivID, setclickedDivID] = useState();
     const [tilCalOpen, setTilCalOpen] = useState(false);
     const [fromCalOpen, setFromCalOpen] = useState(false);
    const [month, setMonth] = useState(); 

     const [activeFromDate, setactiveFromDate] = useState(new Date());
     const [activeTilDate, setactiveTilDate] = useState(new Date());
     const [filmTitle, setfilmTitle] = useState('');
     const [filmDesc, setfilmDesc] = useState('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ullamcorper eget lectus quis ultricies. Nam a libero fermentum, placerat dolor eu, porttitor nibh. Aliquam lacinia finibus ante, ac consequat nisi congue a. Vivamus et arcu ut ante elementum ullamcorper nec at nulla. Nam in mauris posuere, consequat velit ut, rhoncus nunc.');
      function handleFilmDiv (i) {
         setFilmDivOpen((current => !current))
         console.log(i)
         setclickedDivID(i)
      }
      console.log(tilCalOpen)
  return (
    <main style={{position:'relative'}}><div className='filmlist-body' style={{borderBottomLeftRadius:filmDivOpen === true && clickedDivID === index ? '' :'8px',borderBottomRightRadius:filmDivOpen === true && clickedDivID === index ? '' :'8px',width:'953px'}}>
                            <p style={{paddingLeft:'15px'}}>{item.name}</p>
                            <p style={{textAlign:'center'}}> {filmDivOpen === true && clickedDivID === index ? '' 
                           :'01-03-225' }</p> 
                            <p style={{textAlign:'center'}}> {filmDivOpen === true && clickedDivID === index ? '' 
                           :'01-03-225' }</p> 
                            <span style={{marginTop:'10px',textAlign:'center'}}>{filmDivOpen === true && clickedDivID === index ? '': <img src={checkmarkGreen} alt="" /> }</span>                           
                            <span style={{marginTop:'10px',textAlign:'center'}}> {filmDivOpen === true && clickedDivID === index ? '': <img src={checkmarkGreen} alt="" /> }</span>
                             <p style={{textAlign:'center'}}>{filmDivOpen === true && clickedDivID === index ? '': '–'}</p>
                             <p style={{textAlign:'center',width:'123px'}}>{filmDivOpen === true && clickedDivID === index ? '': '–'}</p>
                             <p>{filmDivOpen === true && clickedDivID === index ? '': '33456'}</p>
                            <span style={{position:'absolute',right:'0px',top:'0px'}} onClick={()=>handleFilmDiv(index)}><svg xmlns="http://www.w3.org/2000/svg" width="31" height="55" viewBox="0 0 31 55" fill="none">
                                <path d="M0.353546 23L8.85355 31.5L17.3535 23" stroke="#101010"/>
                                </svg></span>
                        </div>
                        { filmDivOpen === true && clickedDivID === index ? 
                        <section className='openedFilmDiv' >
                          <div style={{display:'flex',paddingTop:'20px',position:'relative',width:'755px'}}>
                            <div style={{display:'flex',flexDirection:'column',marginLeft:'16px',}}>
                                <label htmlFor="" style={{fontWeight:700,color:'#46484c',marginBottom:'5px'}} > Vælg ‘Aktiv fra’  </label>
                                 <div style={{width:'200px',height:'42px',border:'1px solid #ccced1',borderRadius:'5px',position:'relative'}} type="text" ><p style={{padding:'6px'}}>{moment(activeFromDate).format('DD.MM.YYYY')}</p>
                                 <span style={{width:'1px',backgroundColor:'#dedede',display:'inline-block',height:'41px',position:'absolute',right:'38px',top:0}}></span>
                                 <button onClick={() => setFromCalOpen((current => !current))} style={{position:'absolute',right:'3px',top:'3px'}}><img src={calendar} alt="" /></button>
                                 </div>
                            </div>
                                 {fromCalOpen ? (
    <div className='startDatoCal' style={{top:'95px',left:'0%'}}>
        {/* <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',justifyContent:'space-between',margin:'4px',}}>
           <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Startdato</p>
         
        </div> */}
        <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
        <DayPicker 
         month={month} 
            onMonthChange={setMonth}  locale={da} mode="single" ISOWeek  showOutsideDays  showWeekNumber selected= {activeFromDate} captionLayout="dropdown" fromYear={2022} toYear={2030} 
             onSelect={setactiveFromDate} 
              onDayClick={() => setFromCalOpen(false)}
               />
    </div>
  ) : ''}
                              <div style={{display:'flex',flexDirection:'column',width:'270px',marginLeft:'40px'}}>
                                <label htmlFor="" style={{fontWeight:700,color:'#46484c',marginBottom:'5px'}}> Rediger filmtitel  </label>
                                 <div contentEditable='true'  type="text" style={{border:'1px solid #ccced1',borderRadius:'5px',height:'auto',padding:'8px'}}>{filmTitle}</div>
                            </div>
                            <p style={{fontSize:'12px',color:'#46484c',width:'208px',position:'absolute',bottom:'0px',opacity:'0.8',right:0}}>Overskriver filmens standard-filmtitel</p>
                          </div>
                          <div style={{display:'flex',marginTop:'20px',position:'relative'}}>
                            <div style={{display:'flex',flexDirection:'column',marginLeft:'16px'}}>
                                <label style={{fontWeight:700,color:'#46484c',marginBottom:'5px'}} htmlFor="" > Vælg ‘Aktiv til’  </label>
                                 <div style={{width:'200px',height:'42px',border:'1px solid #ccced1',borderRadius:'5px',position:'relative'}} type="text" ><p style={{padding:'6px'}}>{moment(activeTilDate).format('DD.MM.YYYY')}</p>
                                 <span style={{width:'1px',backgroundColor:'#dedede',display:'inline-block',height:'41px',position:'absolute',right:'38px',top:0}}></span>
                                   <button onClick={()=>setTilCalOpen((current => !current))} style={{position:'absolute',right:'3px',top:'3px'}}><img src={calendar} alt="" /></button>
                                 </div>
                            </div>
     {tilCalOpen ? (
    <div className='startDatoCal' style={{top:'80px',left:'0%'}}>
        {/* <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',justifyContent:'space-between',margin:'4px',}}>
           <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Startdato</p>
         
        </div> */}
        <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
        <DayPicker 
         month={month} 
            onMonthChange={setMonth}  locale={da} mode="single" ISOWeek  showOutsideDays  showWeekNumber selected= {activeTilDate} captionLayout="dropdown" fromYear={2022} toYear={2030} 
             onSelect={setactiveTilDate} 
              onDayClick={() => setTilCalOpen(false)}
               />
    </div>
  ) : ''}
                              <div style={{display:'flex',flexDirection:'column',marginLeft:'40px'}}>
                                <label style={{fontWeight:700,color:'#46484c',marginBottom:'5px'}} htmlFor="" > Rediger beskrivelse  </label>
                                 <div contentEditable='true' style={{width:'270px',padding:'8px',fontSize:'12px',color:'#46484c',border:'1px solid #ccced1',opacity:'0.5',borderRadius:'5px'}}>{filmDesc}</div>
                            </div>
                            <p style={{fontSize:'12px',color:'#46484c',width:'210px',opacity:'0.8',right:'0px',top:'18%',marginTop:'40px',marginLeft:'20px'}}>Hvis listen benyttes til slideren på hjemmesiden indsættes denne tekst under filmtitlen på sideren. </p>
                            <button style={{border:'1px solid #909399',height:'40px',width:'94px',position:'absolute',right:'35px',bottom:0,borderRadius:'5px',fontWeight:700,letterSpacing:'0.44px',color:'#46484c'}}>Gem</button>
                          </div>
                         
                        </section> : ''
                        }
                        <button style={{position:'absolute',right:'-10px',top:'15px',}}><img src={close} alt="" /></button>
                        </main>
  )
}

export default FilmlistDiv